// Services
import CartService from "@/app/services/main/cart/cart-service.js";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";

// Components
const ClientHeader = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "client-header" */ "@/app/views/client-view/_shared/client-header/client-header.vue"
    );
const TheFooter = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "the-footer" */ "@/app/views/main-view/_shared/the-footer/the-footer.vue"
    );

const PublicCartCard = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "public-cart-card" */ "@/app/views/client-view/public-products-page/components/public-cart-card/public-cart-card.vue"
    );

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

export default {
    name: "PublicCartContainer",
    components: {
        ClientHeader,
        TheFooter,
        PublicCartCard,
    },
    directive: {},
    filters: {},
    mixins: [toastMessageMixins],
    props: {},
    data() {
        return {
            showMainLogo: true,
            isAPILoading: true,

            publicCartItems: this.$store.getters.getPublicCartItems || [],
            cartItems: [],

            subtotalPrice: 0,
            totalPrice: 0,
        };
    },
    computed: {
        isNativeApp() {
            return this.$store.getters.getIsNativeApp;
        },
        compPublicCartItems() {
            return this.$store.getters.getPublicCartItems;
        },
    },
    watch: {
        compPublicCartItems(newProductItems) {
            this.getTotalPrice(newProductItems);
        },
    },
    async created() {
        const bundleIds =
            this.publicCartItems && this.publicCartItems.length > 0
                ? this.publicCartItems.map(({ bundleId }) => bundleId)
                : [];

        await this.getProductDetails(bundleIds);
    },
    methods: {
        async getProductDetails(bundleIds) {
            this.isAPILoading = true;

            try {
                const productsResponse = await CartService.getPublicCartProductDetails(bundleIds);
                const cartItems = this.$store.getters.getPublicCartItems;

                if (productsResponse.status === STATUS_CODES.SUCCESS) {
                    const responseProducts = productsResponse.data;

                    if (responseProducts && responseProducts.length && cartItems.length) {
                        const cleanedProducts =
                            responseProducts.filter(
                                (item) => item.status !== "I" && item.status !== "D" && !item.subscriptionBundle
                            ) || [];

                        const mappedProducts = [...cleanedProducts].map((product) => {
                            const localStorageProduct = cartItems.find(
                                (localProduct) => product.bundleId === localProduct.bundleId
                            );

                            if (localStorageProduct) {
                                // keep original price fetched from API
                                const currentPrice = product.onSale ? product.salePrice : product.price;
                                return {
                                    ...product,
                                    quantity: localStorageProduct.quantity,
                                    currentPrice,
                                    breed: localStorageProduct.breed,
                                };
                            }

                            return product;
                        });

                        const finalProducts = [...mappedProducts].map(product => {
                            return {
                                ...product,
                                description: product.description ? this.replacePetName(product.description) : ""
                            };
                        })

                        this.cartItems = finalProducts;
                        this.getTotalPrice(mappedProducts);
                        this.$store.dispatch("setPublicCartItems", finalProducts);

                        // remove data from local storage -----------
                        // const invalidProducts =
                        //     responseProducts.filter(
                        //         (item) => item.status === "I" || item.status === "D" || item.subscriptionBundle
                        //     ) || [];

                        // invalidProducts.forEach((product) => {
                        //     this.$store.dispatch("removeFromPublicCart", product.bundleId);
                        // });
                    } else {
                        this.cartItems = [];
                        this.getTotalPrice([]);
                    }
                } else {
                    const { ERROR_GET_PUBLIC_PRODUCTS_CART } = this.toastMessages.publicCart();
                    this.showAPIErrorToast(ERROR_GET_PUBLIC_PRODUCTS_CART, productsResponse);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }
        },
        replacePetName(description) {
            if (!description) {
                return description;
            }

            const petName = this.$route.query && this.$route.query.petName ? this.$route.query.petName : "";

            if (petName) {
                const capitalizedPetName =
                    petName.charAt(0).toUpperCase() + petName.slice(1).toLowerCase();

                return description.replace(new RegExp("PET_NAME", "gi"), capitalizedPetName);
            }

            return description.replace(new RegExp("PET_NAME", "gi"), "your dog");
        },
        getTotalPrice(products) {
            if (!products || !products.length) {
                this.subtotalPrice = 0;
                this.totalPrice = 0;
                return;
            }

            const subtotal = products.reduce((sum, product) => {
                return sum + parseFloat(product.currentPrice) * (product.quantity || 1);
            }, 0);

            this.subtotalPrice = subtotal;
            this.totalPrice = subtotal; // will be the same with subtotal for the mean time, without delivery fee
        },
        goToPublicProducts() {
            this.$router.push("/public-products");
        },
        removeProductFromCart(bundleIdToRemove) {
            this.$swal({
                imageHeight: "30px",
                imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
                imageAlt: "Dog Confirm",
                title: "Remove to Cart",
                text: `Are you sure you want to remove the product?`,
                confirmButtonText: "Confirm",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                reverseButtons: true,
            }).then(async (result) => {
                if (result.value || result.isConfirmed) {
                    this.$store.dispatch("removeFromPublicCart", bundleIdToRemove);
                    this.showCustomSuccessToast("Product has been removed from the cart.");

                    const filteredProducts = this.$store.getters.getPublicCartItems.filter(
                        ({ bundleId }) => bundleId !== bundleIdToRemove
                    );

                    if (filteredProducts) {
                        const latestBundleIds = filteredProducts.map(({ bundleId }) => bundleId);
                        await this.getProductDetails(latestBundleIds);
                    }
                }
            });
        },
    },
};
